import { RouteName } from "@/app/routing/routing";
import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { FTEViewId } from "@agentx/agentx-services";
import { Router } from "@uuip/unified-ui-platform";
import { html, nothing } from "lit-html";
import style from "./InteractionsBlock.scss";
const InteractionsBlock = () => {
    const completeFTE = () => {
        STORE.app.completeFTE(FTEViewId.INTERACTIONS);
    };
    const shouldShowFTE = STORE.app.shouldShowFTE && !STORE.app.isInteractionsFTEViewCompleted;
    return new Router.RouterView.Block({
        template: html `
      <div class="interactions-view">
        ${shouldShowFTE
            ? html `
              <agentx-wc-first-user-experience
                .title=${t("app:fte.interactions.title")}
                info-message=${t("app:fte.interactions.message")}
                info-message-secondary=${t("app:fte.interactions.messageSecondary")}
                illustration-type="Interactions"
                .isDarkMode=${STORE.app.darkMode}
                @close=${completeFTE}
                @got-it=${completeFTE}
                @outside-close=${completeFTE}
              ></agentx-wc-first-user-experience>
            `
            : nothing}
        <agentx-wc-panel-frame heading="${t("app:interactions.interactions")}">
          <agentx-wc-interactions-tab-widget
            .isDarkMode=${STORE.app.darkMode}
            .isRTDIntialized=${STORE.app.isRTDIntialized}
            .interactionsStore=${STORE.interactions}
            .initialCompletedTimeRange=${STORE.session.interactions.initialCompletedTimeRange}
            ?is-grid-collapsed=${STORE.session.interactions.isGridCollapsed}
            .initialParams=${STORE.routing.getExtraRouteParams(RouteName.Interactions)}
            @grid-sidebar-toggled=${(e) => {
            STORE.layout.setRouterViewClasses({ "with-sidebar": e.detail.visible });
        }}
            @initial-completed-time-range-changed=${(e) => {
            STORE.session.interactions.setInitialCompletedTimeRange(e.detail.timeRange);
        }}
            @grid-collapsed-changed=${(e) => {
            STORE.layout.setRouterViewClasses({ expanded: e.detail.isGridCollapsed });
            STORE.session.interactions.setIsGridCollapsed(e.detail.isGridCollapsed);
        }}
            @reset-initial-params=${() => {
            STORE.routing.setExtraRouteParams(RouteName.Interactions, {});
        }}
          ></agentx-wc-interactions-tab-widget>
        </agentx-wc-panel-frame>
      </div>
    `,
        styles: [style]
    });
};
export default InteractionsBlock;
